export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[70px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                <i className="ri-fire-fill text-sm"></i>
                实时更新
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent-100 text-accent-800 text-xs font-medium rounded-full whitespace-nowrap">
                <i className="ri-film-line text-sm"></i>
                高清播放
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full whitespace-nowrap">
                <i className="ri-smartphone-line text-sm"></i>
                即点即看
              </span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              91吃瓜爆料网 - 最新最全的吃瓜视频在线观看平台
            </h1>

            <p className="text-base md:text-lg text-primary-600 font-heading mb-5">
              即点即看，不错过每一个热门爆料
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              91吃瓜爆料网专注聚合全网热门爆料事件完整版录像，覆盖娱乐圈八卦、社会热点事件、网红主播争议与综艺名场面。平台每日更新最新吃瓜视频资源，支持91吃瓜视频在线观看与91吃瓜在线播放，打造一站式吃瓜视频在线看合集，让你随时随地畅享高清吃瓜体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl text-primary-500">10000+</div>
                <div className="text-xs text-foreground-500">吃瓜视频资源</div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl text-accent-500">每日50+</div>
                <div className="text-xs text-foreground-500">实时更新入库</div>
              </div>
              <div className="w-px h-10 bg-background-200 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading text-xl md:text-2xl text-primary-500">全网覆盖</div>
                <div className="text-xs text-foreground-500">热点追踪不漏</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => { e.preventDefault(); document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap no-underline"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-300 text-primary-600 font-medium text-sm rounded-lg hover:bg-primary-50 transition-colors duration-200 cursor-pointer whitespace-nowrap no-underline"
              >
                <i className="ri-bar-chart-line text-lg"></i>
                热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20entertainment%20social%20media%20concept%20with%20glowing%20play%20button%20and%20dynamic%20colorful%20pop%20culture%20elements%2C%20warm%20coral%20red%20and%20amber%20gold%20gradient%20background%2C%20modern%20minimal%20style%2C%20cinematic%20lighting%20atmosphere%2C%20vibrant%20yet%20sophisticated%20composition%2C%20artistic%20rendering%20with%20subtle%20film%20texture%20and%20soft%20glow%20effects&width=800&height=600&seq=91crab-hero-01&orientation=landscape"
                alt="91吃瓜爆料网 - 吃瓜视频在线观看平台"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
              <div className="absolute bottom-3 left-3 flex items-center gap-2 px-3 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-lg">
                <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">正在更新中</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}